import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Tooltip, Avatar } from "@vapor/v3-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Menu,
  MenuItem,
  IconButton,
  ExtendedAvatar,
  VaporIcon,
  Drawer,
  Title,
  VaporToolbar,
  Button,
  TextField,
  Spinner,
  NotificationOverflow,
  NotificationInline,
  AlertTitle,
  Select,
  Typography,
  InputLabel,
  Badge,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Uploader,
  Toast,
  ClickAwayListener,
  CascadingMenu,
  ListItemIcon,
  ListItemText,
} from "@vapor/v3-components";
import { useTranslation } from "react-i18next";
import { usePersistentState } from "../store/usePersistentState";
import {
  getLogonInfoFromCookies,
  saveLogonInfoToCookies,
  deleteLogonInfoFromCookies,
} from "../utils/util";
import {
  faUser,
  faGrid,
  faXmark,
  faPen,
  faList,
  faRotate,
} from "@fortawesome/pro-regular-svg-icons";
import {
  AuthResponse,
  VerifyTokenResponse,
  LogoutResponse,
} from "../services/Models/AuthModel";
import { verifyToken, logout, SSODisassocia } from "../services/authService";
import {
  GetUserProfileResponse,
  SetUserProfileResponse,
} from "../services/Models/UserProfileModel";
import {
  getUserProfile,
  saveUserProfile,
} from "../services/userProfileService";
import { uploadFile, deleteFile } from "../services/FileService";
import { uploadFileRequest } from "../services/Models/FileModel";
import {
  FileDetailsRequest,
  FileDetailsResponse,
} from "../services/Models/DocumentsModel";
import { ChangePassword } from "./ChangePassword";
import { localFilter } from "../pages/Home";
import { useWindowWidth } from "../utils/useWindowWidth";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { FilterListResponse } from "../services/Models/FilterListModel";
import { getFilterList } from "../services/filterListService";
import { CmsFilterDescriptorBase } from "../services/Models/FilterDescriptorModel";
import { PreviewDocument } from "./PreviewDocument";
import { useAuth } from "../Router/AuthProvider";
import { returnError } from "../utils/util";
import i18next from "i18next";

interface ToolbarButtonsProps {
  showFilter?: boolean;
  showReload?: boolean;
  onMenuSelected?: (idFilter: number) => void;
  onReloadFilters?: () => void;
  showIconsOrList?: number; //0=nessuna visualizzaizone, 1=List, 2=Icons
  onClickIconsOrList?: () => void;
}

export const ToolbarButtons: React.FC<ToolbarButtonsProps> = ({
  showFilter,
  showReload,
  onMenuSelected,
  onReloadFilters,
  showIconsOrList,
  onClickIconsOrList,
}) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  const { performLogout } = useAuth();
  const preLanguage = useRef<string>("");
  const windowWidth = useWindowWidth(); // Larghezza della finestra
  const drawerWidth =
    windowWidth > 450 ? Math.max(windowWidth * 0.3, 450) : windowWidth;

  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const getUserNameValue = (): string => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult) {
      return loginResult.UserLogin ?? "";
    } else return "";
  };
  const [error, setError] = useState<string | null>(null);
  const [errorUpload, setErrorUpload] = useState<string | undefined>(undefined);
  const [saveOK, setSaveOK] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [activeSave, setActiveSave] = useState<boolean>(false);
  const userName = useRef(getUserNameValue());
  const [image, setImage] = usePersistentState<string | null>("image", null);
  const [localImage, setLocalImage] = useState<string | null>(null);
  const [showProfile, setShowProfile] = useState<boolean>(false);
  const [showImage, setShowImage] = useState<boolean>(false);
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  const [userProfile, setUserProfile] = useState<
    GetUserProfileResponse | undefined
  >(undefined);
  const [openFilterList, setOpenFilterList] = React.useState(false);
  const refFilterList = React.useRef<HTMLButtonElement | null>(null);
  const clickAway = (event: any) => {
    if (
      refFilterList.current &&
      !refFilterList.current.contains(event.target)
    ) {
      setOpenFilterList(false);
    }
  };
  const filterList = useRef<localFilter[]>(
    JSON.parse(localStorage.getItem("filterList") ?? "null") as localFilter[]
  );

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Funzione di validazione
  const isValidEmail = (email: string): boolean => {
    return !emailRegex.test(email);
  };

  const [files, setFiles] = useState([]);

  const loadOtherFilter = (idx: number) => {
    const currentFilter = filterList.current[idx].filterId;
    if (onMenuSelected) onMenuSelected(currentFilter);
  };

  const onFileUpload = (filesItems: any) => {
    if (filesItems.length > 0) {
      if (!filesItems[0].type.startsWith("image/")) {
        setErrorUpload(t("noImage"));
        return;
      }
      if (filesItems[0].size > 1024 * 1024) {
        setErrorUpload(t("noSize"));
        return;
      }
      setErrorUpload(undefined);

      setFiles((files): any => [filesItems[0]]);

      const file = filesItems[0];
      const url = URL.createObjectURL(file);
      setLocalImage(url);
      // setActiveSave(true);
    }
  };

  const onRemove = (fileIndex: any) => {
    // setActiveSave(true);
    setLocalImage(null);

    setFiles((files) => files.filter((_, i) => i !== fileIndex));
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleChangeImage = (event: any) => {
    setShowImage(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleProfile = () => {
    handleClose();
    if (image) setLocalImage(image);
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading) {
      setShowProfile(true);
      loadUserProfile(loginResult);
    }
  };
  const handleReload = () => {
    if (onReloadFilters) onReloadFilters();
  };

  const callLogout = async () => {
    try {
      const loginResult = getLogonInfoFromCookies();
      if (loginResult && loginResult.SecurityToken && !loading) {
        const result: LogoutResponse = await logout(loginResult.SecurityToken);
        if (result.ResultCode !== "ERROR") {
          if (result.TSID_LogoutUrl !== "")
            window.location.href = result.TSID_LogoutUrl;
          // Redirige al provider OAuth2
          else {
            // deleteLogonInfoFromCookies();
            // localStorage.removeItem("image");
            // localStorage.removeItem("filterList");
            // navigate("/logout");
            performLogout();
          }
        }
        setError(t(result.DetailedMessage));
        return false;
      }
    } catch (error) {
      setError(t("errore interno"));
      return false;
    }
  };

  // const logout = () => {
  //   deleteLogonInfoFromCookies();
  //   localStorage.removeItem("image");
  //   localStorage.removeItem("filterList");
  //   navigate("/");
  // };
  const loadUserProfile = async (loginResult: AuthResponse) => {
    setLoading(true);
    try {
      let result: GetUserProfileResponse = await getUserProfile(
        loginResult.SecurityToken,
        loginResult.Language ?? "it",
        userName.current,
        true
      );
      if (result && result.ResultCode !== "ERROR") {
        setActiveSave(false);
        if (image) setLocalImage(image);
        else setLocalImage(null);
        setUserProfile(result);
        setFiles([]);
        if (result.Language === "") result.Language = "it";
        preLanguage.current = result.Language;
      } else {
        setError(t(returnError(result)));
      }
    } catch (error) {
      setError(t("errore interno"));
    } finally {
      setLoading(false);
    }
  };

  const disassociaTSID = async () => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading) {
      setLoading(true);
      try {
        const result: AuthResponse = await SSODisassocia(
          loginResult.SecurityToken
        );
        if (result && result.ResultCode !== "ERROR") {
          loadUserProfile(loginResult);
          setSaveOK(t("disassociaTDID"));
        } else {
          setError(t(returnError(result)));
          console.error("Dissocia TSID Error :", result.DetailedMessage);
        }
      } catch (error) {
        setError(t("errore interno"));
        console.error("Dissocia TSID  Error :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const reloadFilters = async (loginResult: AuthResponse) => {
    try {
      const result: FilterListResponse = await getFilterList(
        loginResult.SecurityToken,
        loginResult.Language ?? "it",
        localSiteParameters.current.ContPubFiltro
      );
      if (result && result.ResultCode !== "ERROR") {
        console.log("getFilter successful:");
        const locFilters: localFilter[] = result.Filters.map(
          (filter: CmsFilterDescriptorBase) => {
            const appFilter: localFilter = {
              filterId: filter.FilterId,
              filterName: filter.FilterName,
              IconFile: filter.IconFile,
              TotPub: filter.TotPub,
              LinkedDocs: filter.LinkedDocs === "1" ? true : false,
              noDownloadVideo:
                filter.DownloadVideo === "nodownload" ? true : false,
            };
            return appFilter;
          }
        );
        localStorage.setItem("filterList", JSON.stringify(locFilters));
      } else setError(t(returnError(result)));
    } catch (error) {}
  };

  const uploadUserProfile = async () => {
    let loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading && userProfile) {
      setLoading(true);
      try {
        const result: SetUserProfileResponse = await saveUserProfile(
          loginResult.SecurityToken,
          userProfile.Language,
          userProfile.Name,
          userProfile.LastName,
          userProfile.EMail
        );
        if (result && result.ResultCode !== "ERROR") {
          console.log("getFilter successful:");
          setSaveOK(t("userProfile"));
          if (preLanguage.current !== userProfile.Language) {
            loginResult.Language = userProfile.Language;
            await reloadFilters(loginResult);
            saveLogonInfoToCookies(loginResult);
            if (i18next.language !== userProfile.Language) {
              await i18next
                .changeLanguage(userProfile.Language)
                .then(() => {
                  i18next
                    .reloadResources()
                    .then(() => {
                      console.log("Risorse ricaricate:", i18next.language);
                    })
                    .catch((error) => {
                      console.error("Errore nel cambio lingua:", error);
                    });
                })
                .catch((error) => {
                  console.error("Errore nel cambio lingua:", error);
                });
            }
            // window.location.reload();
          }
          setShowProfile(false);
        } else {
          setError(t(returnError(result)));
          console.error("uploadUserProfile Error :", "no result");
        }
      } catch (error) {
        setError(t("errore interno"));
        console.error("uploadUserProfile Error :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const deleteImageProfile = async (idObject: number) => {
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading && userProfile) {
      setLoading(true);
      try {
        const result: FileDetailsResponse = await deleteFile(
          loginResult.SecurityToken,
          idObject,
          0
        );
        if (result && result.ResultCode !== "ERROR") {
          if (await checkToken(true)) {
            // setImage(localImage!);
            setSaveOK(t("immagine"));
            setShowImage(false);
          } else setError(t("errore interno"));
        } else {
          setError(t(returnError(result)));
        }
      } catch (error) {
        setError(t("errore interno"));
      } finally {
        setLoading(false);
      }
    }
  };

  const uploadImage = () => {
    if (files.length > 0) {
      uploadProfileImage(
        userProfile!.IdScheda,
        (files[0] as any).name,
        files[0]
      );
    } else {
      deleteImageProfile(userProfile!.IdScheda);
    }
  };

  const checkToken = async (downloadFile: boolean) => {
    try {
      const loginResult = getLogonInfoFromCookies();
      if (loginResult && loginResult.SecurityToken && !loading && userProfile) {
        const result: VerifyTokenResponse = await verifyToken(
          loginResult.SecurityToken,
          true
        );
        if (result.ResultCode !== "ERROR") {
          saveLogonInfoToCookies({
            ...result,
            rememberMe: loginResult.rememberMe,
          });
          if (result && result.Image != null && result.Image !== undefined) {
            setImage(window.config.BASE_URL + "/preview/" + result.Image);
            setLocalImage(window.config.BASE_URL + "/preview/" + result.Image);
          } else {
            setImage(null);
            setLocalImage(null);
          }
          setFiles([]);
          return true;
        }
        return false;
      }
    } catch (error) {
      setError(t("errore interno"));
      return false;
    }
  };

  const uploadProfileImage = async (
    idObject: number,
    fileName: string,
    file: any
  ) => {
    setLoading(true);
    const loginResult = getLogonInfoFromCookies();
    if (loginResult && loginResult.SecurityToken && !loading && userProfile) {
      try {
        const result: FileDetailsResponse = await uploadFile(
          loginResult.SecurityToken,
          idObject,
          fileName,
          "",
          file
        );
        if (result && result.ResultCode !== "ERROR") {
          if (await checkToken(true)) {
            // setImage(localImage!);
            setSaveOK(t("immagine"));
            setShowImage(false);
          } else setError(t("errore interno"));
        } else {
          setError(t(returnError(result)));
        }
      } catch (error) {
        setError(t("errore interno"));
        console.error("uploadProfileImage Error :", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const changeImage = () => {
    return (
      <Dialog
        aria-describedby="alert-dialog-description"
        aria-labelledby="alert-dialog-title"
        // fullWidth={true}
        // maxWidth={"lg"}
        open={showImage}
      >
        <DialogTitle>
          {t("Immagine")}
          <IconButton
            color="primary"
            onClick={() => {
              if (image) setLocalImage(image);
              else setLocalImage(null);
              setShowImage(false);
            }}
            variant="text"
          >
            <VaporIcon icon={faXmark} size="s" color="primary" />
          </IconButton>
        </DialogTitle>
        <Divider variant="fullWidth" />
        <DialogContent sx={{ p: 2 }}>
          <Box
            width="100%"
            height="100%"
            display="flex" // Aggiunto per abilitare il layout flex
            flexDirection="column" // Per disporre gli elementi verticalmente
            alignItems="center" // Centra orizzontalmente gli elementi
            justifyContent="center" // Centra verticalmente gli elementi
            margin="10"
          >
            {localImage === null ? (
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0", // Sfondo
                  border: "2px solid #000", // Bordo
                  marginBottom: "12px",
                }}
              >
                <FontAwesomeIcon
                  icon={faUser}
                  style={{ fontSize: 80, color: "#888" }}
                />
              </Box>
            ) : (
              // <IconButton color="secondary" onClick={handleClick}>
              //   <VaporIcon icon={faUser} size="32px" color="inverse" />
              // </IconButton>
              <Avatar
                alt={t("Immagine")}
                src={localImage}
                onClick={handleClick}
                sx={{ width: 150, height: 150 }}
              />
            )}
            <Uploader
              buttonLabel={t("selectFile")}
              draggableText={t("dragFile")}
              dropText={t("dropFile")}
              description={
                t("Selezionare un'immagine di dimensioni inferiori a") + " 1mb"
              }
              buttonVariant="outlined"
              errorMessage={errorUpload}
              draggable
              error={true}
              disabled={false}
              onFileUpload={onFileUpload}
              inputFileProps={{
                multiple: true,
              }}
              files={files}
              onRemove={onRemove}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              mr: 1,
            }}
            onClick={() => {
              deleteImageProfile(userProfile!.IdScheda);
            }}
            color="secondary"
          >
            {t("delete")}{" "}
          </Button>
          <Button
            variant="outlined"
            sx={{
              mr: 1,
            }}
            onClick={() => {
              // setActiveSave(true);
              uploadImage();
            }}
            color="primary"
          >
            {t("change")}{" "}
          </Button>
        </DialogActions>
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
      </Dialog>
    );
  };
  const [hover, setHover] = useState(false);

  return (
    <div>
      <Box display="flex" gap={2} marginRight={2} alignItems="center">
        {/* {(showFilter ?? false) && (
          <Tooltip title={t("filters-list")} arrow>
            <VaporIcon icon={faGrid} size="xl" color="inverse" />
          </Tooltip>
        )} */}
        {(showIconsOrList ?? 0) > 0 && (
          <Tooltip
            title={showIconsOrList === 1 ? t("elenco") : t("galleria")}
            arrow
          >
            <IconButton color="secondary" onClick={onClickIconsOrList}>
              <VaporIcon
                icon={showIconsOrList === 1 ? faList : faGrid}
                size="xl"
                color="inverse"
              />
            </IconButton>
          </Tooltip>
        )}
        {showReload && (
          <Tooltip title={t("filters-reload")} arrow>
            <IconButton color="secondary" onClick={handleReload}>
              <VaporIcon icon={faRotate} size="xl" color="inverse" />
            </IconButton>
          </Tooltip>
        )}
        {showFilter && filterList && (
          <div>
            {/* <Tooltip title={t("filters-list")} arrow>
              <IconButton
                color="secondary"
                ref={refFilterList}
                onClick={() => setOpenFilterList(!openFilterList)}
              >
                <VaporIcon icon={faGrid} size="24px" color="inverse" />
              </IconButton>
            </Tooltip> */}
            <Button
              id="basic-button"
              variant="contained"
              ref={refFilterList}
              onClick={() => setOpenFilterList(!openFilterList)}
            >
              {t("filters-list")}
            </Button>
            <ClickAwayListener onClickAway={(event) => clickAway(event)}>
              <CascadingMenu
                anchorEl={refFilterList.current}
                open={openFilterList}
              >
                {filterList.current.map((filter, idx) => (
                  <MenuItem
                    onClick={() => {
                      setOpenFilterList(false);
                      loadOtherFilter(idx);
                    }}
                  >
                    <ListItemIcon>
                      <Badge
                        overlap="circular"
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        color="counter"
                        // icon={<FontAwesomeIcon fontSize={12} icon={faPen} />}
                        size="small"
                        variant="standard"
                        badgeContent={filter.TotPub}
                      >
                        <img
                          src={`${window.config.BASE_URL}/icon_archive/${filter.IconFile}`}
                          alt={filter.filterName}
                          style={{ width: 24, height: 24 }} // Imposta la dimensione dell'icona
                        />
                      </Badge>
                    </ListItemIcon>
                    <ListItemText sx={{ marginLeft: "12px" }}>
                      {filter.filterName}
                    </ListItemText>
                  </MenuItem>
                ))}
              </CascadingMenu>
            </ClickAwayListener>
          </div>
        )}
        <Tooltip title={t("user-home")} arrow>
          <Box
            display="flex"
            flexDirection="row"
            gap={0}
            sx={{
              // alignItems: 'center',
              // justifyContent: 'center',
              paddingLeft: 1,
              paddingRight: 1,
              borderRadius: hover ? "15px" : "4px",
              border: hover ? "2px solid #1976d2" : "2px solid transparent",
              transition: "all 0.3s ease", // Anima il cambio di bordo
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {image === null ? (
              <IconButton color="secondary" onClick={handleClick}>
                <VaporIcon icon={faUser} size="xl" color="inverse" />
              </IconButton>
            ) : (
              <IconButton
                color="secondary"
                onClick={handleClick}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent", // Disabilita il cambio di colore
                    boxShadow: "none", // Disabilita l'ombra che appare al passaggio del mouse
                  },
                }}
              >
                <ExtendedAvatar
                  alt="Remy Sharp"
                  size="large"
                  src={image}
                  onClick={handleClick}
                />
              </IconButton>
            )}
            <Button
              color="primary"
              variant="text"
              onClick={handleClick}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent", // Disabilita il cambio di colore
                  boxShadow: "none", // Disabilita l'ombra che appare al passaggio del mouse
                  textDecoration: "none !important",
                },
              }}
            >
              <Typography
                component="div"
                variant="bodyLargeHeavy"
                color="contentLight"
              >
                {userName.current}
              </Typography>
            </Button>
          </Box>
        </Tooltip>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={handleProfile}>{t("user-home")}</MenuItem>
          <MenuItem
            onClick={() => {
              setShowChangePassword(true);
            }}
          >
            {t("change-pass")}
          </MenuItem>
          <MenuItem onClick={callLogout}>{t("logout")}</MenuItem>
        </Menu>
      </Box>
      <Drawer
        anchor="right"
        hideBackdrop
        onClose={function Ga() {}}
        width={drawerWidth}
        open={showProfile}
      >
        <Title
          divider
          rightItems={[
            <IconButton
              color="primary"
              onClick={() => {
                setShowProfile(false);
              }}
              variant="text"
            >
              <VaporIcon icon={faXmark} size="s" color="primary" />
            </IconButton>,
          ]}
          title={t("user-home")}
        />
        <Box padding={2} margin={2}>
          <TextField
            variant="outlined"
            label={t("home-user-name")}
            id="name"
            style={{
              width: 400,
            }}
            value={userProfile ? userProfile.Name : ""}
            onChange={(e) => {
              if (userProfile?.Name !== e.target.value) setActiveSave(true);
              setUserProfile({ ...userProfile!, Name: e.target.value });
            }}
            autoFocus
          />
          <TextField
            variant="outlined"
            label={t("home-user-lastname")}
            id="lastName"
            style={{
              width: 400,
              marginTop: 32,
            }}
            value={userProfile ? userProfile.LastName : ""}
            onChange={(e) => {
              if (userProfile?.LastName !== e.target.value) setActiveSave(true);
              setUserProfile({ ...userProfile!, LastName: e.target.value });
            }}
          />
          <TextField
            variant="outlined"
            label={t("home-user-mail")}
            id="eMail"
            style={{
              width: 400,
              marginTop: 32,
            }}
            value={userProfile ? userProfile.EMail : ""}
            onChange={(e) => {
              if (userProfile?.EMail !== e.target.value) setActiveSave(true);
              setUserProfile({ ...userProfile!, EMail: e.target.value });
            }}
            error={isValidEmail(userProfile ? userProfile.EMail : "")}
          />
          {userProfile &&
            userProfile.SSOEMail &&
            userProfile.SSOEMail !== "" && (
              <TextField
                variant="outlined"
                label={t("Associazione con TeamSystem ID")}
                id="eMailSSO"
                readOnly
                style={{
                  width: 400,
                  marginTop: 32,
                }}
                value={userProfile ? userProfile.SSOEMail : ""}
              />
            )}
          <InputLabel
            id="select-label"
            style={{
              width: 400,
              marginTop: 32,
            }}
          >
            {t("home-user-lang")}
          </InputLabel>
          <Select
            labelId="select-language"
            value={userProfile ? userProfile.Language : "it"}
            onChange={(event: any) => {
              const newLanguage = event.target.value as string;
              if (userProfile?.Language !== newLanguage) setActiveSave(true);
              setUserProfile({ ...userProfile!, Language: newLanguage });
            }}
            displayEmpty
            label={t("home-user-lang")}
            style={{
              width: 400,
            }}
          >
            {userProfile?.Languages.map((language) => (
              <MenuItem key={language.Id} value={language.Id.toString()}>
                <Box display="flex" alignItems="center" gap={2}>
                  <img
                    src={
                      window.config.BASE_URL + "/images/" + language.Id + ".png"
                    }
                    alt={language.Id}
                    style={{ width: 20, height: 20 }}
                  />
                  <Typography>{language.Descr}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
          <InputLabel
            id="select-label"
            style={{
              width: 400,
              marginTop: 32,
              marginBottom: 12,
            }}
          >
            {t("Immagine")}
          </InputLabel>
          <Badge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            color="counter"
            // icon={<FontAwesomeIcon fontSize={12} icon={faPen} />}
            size="large"
            variant="standard"
            badgeContent={
              <IconButton
                onClick={handleChangeImage}
                disableRipple
                size="small"
                sx={{
                  backgroundColor: "transparent", // Sfondo di base
                  "&:hover": {
                    backgroundColor: "transparent", // Nessuna evidenziazione
                  },
                  "&:active": {
                    backgroundColor: "transparent", // Nessuna evidenziazione durante il clic
                  },
                }}
              >
                <FontAwesomeIcon icon={faPen} fontSize={12} />
              </IconButton>
            }
          >
            {localImage === null ? (
              <Box
                sx={{
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0", // Sfondo
                  border: "2px solid #000", // Bordo
                }}
              >
                <FontAwesomeIcon
                  icon={faUser}
                  style={{ fontSize: 80, color: "#888" }}
                />
              </Box>
            ) : (
              // <IconButton color="secondary" onClick={handleClick}>
              //   <VaporIcon icon={faUser} size="32px" color="inverse" />
              // </IconButton>
              <Avatar
                alt={t("Immagine")}
                src={localImage}
                onClick={handleClick}
                sx={{ width: 150, height: 150 }}
              />
            )}
            {/* </FormControl> */}
          </Badge>
        </Box>
        {changeImage()}
        <VaporToolbar
          contentRight={[
            <Button
              variant="outlined"
              onClick={() => {
                setShowProfile(false);
              }}
            >
              {t("cancel")}
            </Button>,
            userProfile &&
            userProfile.SSOEMail &&
            userProfile.SSOEMail !== "" ? (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  disassociaTSID();
                }}
              >
                {t("disassociaTSID")}
              </Button>
            ) : null,
            <Button
              variant="contained"
              onClick={() => {
                uploadUserProfile();
              }}
              disabled={
                !activeSave ||
                isValidEmail(userProfile ? userProfile.EMail : "")
              }
            >
              {t("save")}
            </Button>,
          ]}
          size="medium"
          variant="regular"
          withoutAppBar
        />
        {loading && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
        {error && (
          <NotificationOverflow severity="error" onClose={() => setError(null)}>
            <AlertTitle>{t("error-header")}</AlertTitle>
            {error}
          </NotificationOverflow>
        )}
        <Toast
          open={saveOK ? true : false}
          anchorOrigin={{
            horizontal: "right",
            vertical: "top",
          }}
          autoHideDuration={2000}
          onClose={() => setSaveOK(null)}
        >
          <NotificationInline
            severity="success"
            onClose={() => setSaveOK(null)}
          >
            <AlertTitle>{saveOK}</AlertTitle>
            {t("saveOK")}
          </NotificationInline>
        </Toast>
      </Drawer>
      <ChangePassword
        title={t("change-password")}
        open={showChangePassword}
        onClose={() => {
          setShowChangePassword(false);
        }}
      />
    </div>
  );
};
